import { createContext } from "react";
export let lang = "en";
export const LangContext = createContext(lang);